// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xeaxlorcdqarwietiodo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhlYXhsb3JjZHFhcndpZXRpb2RvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgyODYyNzAsImV4cCI6MjA2Mzg2MjI3MH0.AoIq4KZoLeCs8UHEFtavbakYmPukRLAar0wbRf77asg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);